import type { RefObject } from 'react';
import { fadeFromTo } from '../../../../util/animation/fade/fade';

interface HamburgerButtonRefs {
  elementRef: RefObject<HTMLButtonElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: HamburgerButtonRefs,
): void {
  timeline.fromTo(elementRef.current, {}, {});
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: HamburgerButtonRefs,
): void {
  timeline.add(fadeFromTo(elementRef.current as HTMLElement));
}
